const webllm = () => import("@mlc-ai/web-llm");

export const MODEL_ID = "Qwen2.5-1.5B-Instruct-q4f16_1-MLC";

export const SYSTEM_PROMPT =
  "Tu es PêcheAI, un guide de pêche expert et passionné en France. " +
  "Tu donnes des conseils précis et concrets sur les techniques, leurres, appâts, la météo, " +
  "les saisons et le choix du matériel. Réponds toujours en français, de façon claire et courte " +
  "(maximum 150 mots), avec des listes quand c'est utile. Rappelle qu'une carte de pêche valide " +
  "est obligatoire quand c'est pertinent. Si tu n'es pas sûr d'une règle locale, conseille de vérifier auprès de la fédération départementale.";

let enginePromise = null;

export const checkSupport = async () => {
  if (!navigator.gpu) return false;
  try {
    return !!(await navigator.gpu.requestAdapter());
  } catch {
    return false;
  }
};

export const isModelCached = () =>
  webllm().then((m) => m.hasModelInCache(MODEL_ID)).catch(() => false);

export const loadEngine = (onProgress) => {
  if (!enginePromise) {
    const worker = new Worker(new URL("./llm.worker.js", import.meta.url), { type: "module" });
    enginePromise = webllm()
      .then((m) => m.CreateWebWorkerMLCEngine(worker, MODEL_ID, { initProgressCallback: onProgress }))
      .catch((e) => {
        enginePromise = null;
        worker.terminate();
        throw e;
      });
  }
  return enginePromise;
};
